import { useContext, useEffect, useState } from "react";
import "./Forgotpassword.scss";
import { Form, Button } from "react-bootstrap";
import { BankUserContext } from "../../bankUserContext";
import { toast } from "react-toastify";
import { Field, getFormValues, reduxForm } from "redux-form";
import FinSpinner from "../../commonfields/FinSpinner";
import { connect } from "react-redux";
import logoFooter from "../../images/logoFooter.svg";
import Service from "../../services";
import { TextField } from "common-fields";
import validate from "../layout/Leads/NewLead/Validate";
import { APP_Config } from "../../utils/AppConfig";
import Logo from "../../images/NoLogo.svg";

const ForgotUsername = (props: any) => {
  const { LogoData } = props;
  const service = new Service();
  const [email, setEmail] = useState<string>("");
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [theme, setTheme] = useState("default");

  const getIsoNameByUrl = () => {
    //
  };

  useEffect(() => {
    document.body.classList.add("forgotBG");
    getIsoNameByUrl();
    return () => {
      document.body.classList.remove("forgotBG");
    };
  }, []);
  const bankUserContext = useContext(BankUserContext);
  if (bankUserContext.bankuserDetails !== null) {
    //
  }
  const getEmailHandler = (e: any) => {
    setEmail(e.target.value);
  };

  const submitHandler = (values: any) => {
    setLoader(true);
    const data = {
      screen: "LoginPage",
      sections: "ForgotUsername",
      email: values.email,
      isJsonReturnObject: false,
    };
    service
      .forgotUsername(data)
      .then((response: any) => {
        if (response.status === 200) {
          setLoader(false);
          setSuccess(true);
          props.initialize({
            email: "",
          });
        } else {
          setLoader(false);
          setSuccess(true);

          // toast.error(
          //   <>
          //     <div className="fileErrorMessage">Something went wrong..</div>
          //   </>
          // );
        }
      })
      .catch((error: any) => {
        if (error.response.data) {
          setTimeout(() => {
          setLoader(false);
            setSuccess(true);
          }, 1000);
          

          //toast.error(error.response.data.errorMessage);
        }
      });
  };
  const loginbtn = () => {
    //eslint-disable-next-line max-len
    return (window.location.href = `/api/authorization/authorize?clientId=${APP_Config().REACT_APP_CLIENT_ID}`);
  };
  return (
    <div className="vHeight">
      {success ? (
        <div className="container-fluid userResetScreens">
          <div className="flex-1">
            <img
              className="mainLogo"
              src={
                LogoData.find((item: any) => item.iconkey === "headerIcon")
                  ?.logopath || Logo
              }
              alt="logo"
            />
          </div>
          <div className="form-signinPasswordSucces">
            <div className="smallLogo">
              <img
                //className="mainLogo"
                src={
                  LogoData.find((item: any) => item.iconkey === "loginIcon")
                    ?.logopath || Logo
                }
                alt="logo"
              />
            </div>
            <h2 className="form-signin-heading">Forgot Username</h2>
            <h6 className="successHeading1">
            A recovery link has been sent to the email associated with your account
            </h6>
            <div>
              <div>
                <Button className="btnBacktoSignIn" onClick={() => loginbtn()}>
                  Back to Sign In
                </Button>
              </div>
            </div>
          </div>
          <p className="d-flex footerLogo">
          {LogoData.find((item: any) => item.iconkey === "poweredBy")?.logoname}
            <img src={logoFooter} alt="footerLogo" />
          </p>
        </div>
      ) : (
        <div className="container-fluid userResetScreens">
          <div className="flex-1">
            <img
              className="mainLogo"
              src={
                LogoData.find((item: any) => item.iconkey === "headerIcon")
                  ?.logopath || Logo
              }
              alt="logo"
            />
          </div>
          <div className="form-signinFGUsername">
            <div className="backBtn">
              <span onClick={() => loginbtn()}>Back to Sign In</span>
            </div>
            <div className="smallLogo">
              <img
                //className="mainLogo"
                src={
                  LogoData.find((item: any) => item.iconkey === "loginIcon")
                    ?.logopath || Logo
                }
                alt="logo"
              />
            </div>
            <div className="fgUsernameHeading">Forgot Username</div>
            <h6 className="form-signin-heading">
              Enter the email associated with your account{" "}
            </h6>

            <Form onSubmit={props.handleSubmit(submitHandler)}>
              <Form.Group className="formBasicEmailFGUserName">
                <Field
                  name="email"
                  component={TextField}
                  label="Email"
                  type="email"
                  value={email}
                  onChange={getEmailHandler}
                />
              </Form.Group>
              <div className="btnWrapper">
                <Button
                  type="submit"
                  className="btn-white btn-submit3"
                  disabled={props.invalid || props.pristine}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </div>
          <p className="d-flex footerLogo">
          {LogoData.find((item: any) => item.iconkey === "poweredBy")?.logoname}
            <img src={logoFooter} alt="footerLogo" />
          </p>
        </div>
      )}

      {loader ? <FinSpinner /> : null}
    </div>
  );
};
export default connect((state: any) => {
  return {
    initialValues: {},
    formValues: getFormValues("ForgotUsername")(state),
  };
})(
  reduxForm<Record<string | number, unknown>, any>({
    form: "ForgotUsername",
    validate,
  })(ForgotUsername)
);
